//  ----------------------------------------------------------------------------
//  Dependencies
//  ----------------------------------------------------------------------------

//  -- Chapters -----------------------
import { filter, find, flatMap, get, map } from "lodash";
import { isBeforTime, LEVELS } from "utils/methods/math"
import { BookSynoname , BOOKORDER } from 'utils/config/reference';
import moment from 'moment'
import * as Sentry from '@sentry/react';
import { resource_types } from "store/extraResource/constants";
export const ebookConfigDinamic = (id,allBooks) => {
    try {
        let dataBook = {}
        const dbook = find(allBooks, x => x.id == id);
            if (dbook) {
                dataBook = {
                    bookId: dbook.id,
                    count: false,
                    dataBook: dbook,
                    description: dbook.description
                }
            }else{
                return ({
                    content: [],
                    structures: [],
                });
            }
        const bookSubTopics = map(dataBook.dataBook.subTopics, sb=>({
            id: sb.subTopicId.toString(),
            finish: sb.finishPage.toString(),
            start: sb.startPage.toString(),
            shortName: sb.shortName.toString(),
            subUnits: sb.subUnits
        }))
        return {
            content: getBookContent(id,allBooks,null,null),
            structures: bookSubTopics,
        };
    } catch (error) {
        Sentry.captureException(`644 Error in ebookConfigDinamic: ${error}`);
        console.log(error, "error in databook")
        return {
            content: [],
            structures: [],
        };
    }
};

export const getBookContent = ( id,allBooks , start=null , end=null)=> {
    try {
      if (!id) return [];
      const book = find(allBooks, k => k.id == id);
      if (book) {
        const content = map(book.pages, (p, i) => {
          return {
            id: i,
            pageId: p.pageId,
            src: p.resource,
            tip: p.tip,
            video: p.video,
            description: p.description,
            numberMasked: p.NumberMasked || p.pageId,
            answerPageSrc: find(
              book.pagesTeacher,(k) => k.pageId == p.pageId,
            )?.resource,
            teacherEditionPageSrc: find(book.teacherEdition,(k) => k.pageId == p.pageId)?.resource,
            thumbnail:p.thumbnail ||  p.resource
          };
        })
        if ((typeof start === 'string' || typeof start === 'number') && (typeof end === 'number' || typeof end === 'string')) {
            const startIndex = content.findIndex(page => page.pageId == start);
            const endIndex = content.findIndex(page => page.pageId == end);
            return content.slice(startIndex, endIndex + 1);
        } else {
          return content;
        }
      }
      return [];
    } catch (error) {
        Sentry.captureException(`645 Error in getBookContent: ${error}`);
      return [];
    }
  };
//  -- Image fetch --------------------
export const imageFetch = (booksAllList, chapter, page) => {
    let url = ""
    if (Array.isArray(booksAllList)) {
        let dataBook = filter(booksAllList, x => x && x.id == chapter);
        if (Array.isArray(dataBook) && dataBook[0] && dataBook[0].pages != undefined) {
            let dataPage = filter(dataBook[0].pages, x => x.pageId == page);
            url = dataPage[0]?.resource;
        }
    }
    return url;
};

export const imageFetchResource = (booksAllList, chapter, page) => {
    let url = ""
    if (Array.isArray(booksAllList)) {
        let dataBook = filter(booksAllList, x => x && x.id == chapter);
        if (Array.isArray(dataBook) && dataBook != undefined) {
            let dataPage = filter(dataBook, x => x.pageId == page);
            url = dataPage.length > 0 ? dataPage[0].resource : '';
        }
    }
    return url;
};

export const imageFetchDinamic = (chapter, page, listAllBooks) => {
    try {
        if (Array.isArray(listAllBooks)) {
            const dataBook = find(listAllBooks, x => Number(x.id) == Number(chapter));
            if (dataBook && dataBook.pages) {
                if (dataBook && dataBook.pages) {
                    const dataPage = find(dataBook.pages, x => Number(x.pageId) == Number(page));
                    return dataPage;
                }
            }
        }
        return { resource: null }
    } catch (error) {
        return { resource: null }
    }
}

export const imageFetchFromPodcast = (id, resources) => {
    const allresourcesVideo = flatMap(map(resources, k => k.videos))
    return get(find(allresourcesVideo, ['id', id]), 'thumbnail', '')
}
export const getPodcastBookName = (id, resources) => {
    const allresourcesVideo = flatMap(map(resources, k => k.videos))
    return get(find(allresourcesVideo, ['id', id]), 'displayName', '')
}
export const getBookDisplayName = (AllBook, chapter, hasName , videos, resources) => {
    let chapterName = "";
    if (isEbook(chapter,AllBook)) {
        chapterName = get(find(AllBook, ["id", chapter]), "description", "");
    } else {
         if (isVideo(chapter,resources)) {
            const videoName = get(find(videos, ['id', chapter]), 'displayName', '');
            chapterName = hasName ? `Video ${videoName||''}` : "Video";
        }
        else {
            const postCastName =  getPodcastBookName(chapter, resources);
            if(postCastName){
                chapterName = postCastName
            }else{
                chapterName =``
            }
           
        }
    }
    return chapterName;
  };
  


//  -- Structure fetch ----------------
export const structureFetch = (booksAllList, chapter, page) => {
    let newSubtopics = [];
    let bookSubTopics
    if (Array.isArray(booksAllList)) {
        let dataBook = filter(booksAllList, x => x && x.id == chapter);
        bookSubTopics = dataBook[0]?.subTopics;
    }
    for (var sub in bookSubTopics) {
        newSubtopics.push({
            id: bookSubTopics[sub].subTopicId.toString(),
            finish: bookSubTopics[sub].finishPage.toString(),
            start: bookSubTopics[sub].startPage.toString(),
            shortName: bookSubTopics[sub].shortName.toString(),
            subUnits: bookSubTopics[sub].subUnits
        })
    }
    const structures = newSubtopics;

    for (let i = 0; i < structures.length; i++) {
        const structStart = structures[i].start;
        const structEnd = structures[i].finish;

        if (parseInt(page, 10) <= parseInt(structEnd, 10) && parseInt(page, 10) >= parseInt(structStart, 10)) {
            return `Subtema ${i + 1}`;
        }
    }
};

const parseBubbleNoteAccessable = (note) => {
    const raw = note.accessable != null ? note.accessable : get(note, 'content.accessable');
    if (raw == null) return null;
    if (typeof raw === 'string') {
        try {
            const parsed = JSON.parse(raw);
            return Array.isArray(parsed) ? parsed : null;
        } catch {
            return null;
        }
    }
    return Array.isArray(raw) ? raw : null;
};

//  -- Bubble Note Visible for Class ---------
export const bubbleNoteVisibleForClass = (note, chapter, classId, isAssessmentBook) => {
    const chapterMatch = isAssessmentBook && note.bookId
        ? String(note.bookId) === String(chapter)
        : String(note.chapter) === String(chapter);
    if (!chapterMatch) return false;
    if (!classId) return true;

    const accessableList = parseBubbleNoteAccessable(note);
    if (accessableList != null && accessableList.length > 0) {
        for (let i = 0; i < accessableList.length; i += 1) {
            const item = accessableList[i];
            if (item === 'All' || item === 'all') return true;
            if (item && typeof item === 'object' && item.classes_id != null) {
                if (String(item.classes_id).trim().toLowerCase() === String(classId).trim().toLowerCase()) {
                    return true;
                }
            }
        }
        return false;
    }

    return String(note.classId) === String(classId);
};
//  -- Newsletter Image fetch ---------

export const getBookData = (activities, quizzes, questions, notes, likes, interactions, classActivities, classQuizzes, chapter, classId, isAssessmentBook , teacher_id) => {
    const clonedActivities = filter(activities, k => k.cloneId && (!teacher_id||k.createdBy==teacher_id)).map(k => k.cloneId)
    const _activities = filter(activities, k => !clonedActivities.includes(k.id))
    const _quizzes = filter(quizzes, k => !clonedActivities.includes(k.id))
    const filterByBookId = x =>isAssessmentBook&&x.bookId?x.bookId == chapter : x.chapter == chapter;
    const filteDatarByBookId = x =>isAssessmentBook && get(x,"data.bookId") ?get(x,"data.bookId") == chapter : get(x,"data.chapter") == chapter;
    return {
        "activities": filter(_activities, (activity) => activity.chapter == chapter),
        "quizzes": filter(_quizzes, filterByBookId),
        "notes": filter(notes, (note) => bubbleNoteVisibleForClass(note, chapter, classId, isAssessmentBook)),
        "interactions": filter(interactions, (interaction) => interaction.chapter == chapter),
        "classActivities": filter(classActivities, (classActivity) => classActivity.data?.chapter == chapter),
        "classQuizzes": filter(classQuizzes, filteDatarByBookId),
    }
}
export const extensionGetBookData = (activities, quizzes, questions, notes, likes, interactions, classActivities, classQuizzes, chapter, classId, isAssessmentBook , teacher_id, combineBookId) => {
    const clonedActivities = filter(activities, k => k.cloneId && (!teacher_id||k.createdBy==teacher_id)).map(k => k.cloneId)
    const _activities = filter(activities, k => !clonedActivities.includes(k.id))
    const _quizzes = filter(quizzes, k => !clonedActivities.includes(k.id))
    const filterByBookId = x =>isAssessmentBook&&x.bookId?x.bookId == chapter : x.chapter == chapter;
    const filteDatarByBookId = x =>isAssessmentBook && get(x,"data.bookId") ?get(x,"data.bookId") == chapter : get(x,"data.chapter") == chapter;
    const adminClassActivity = filter(classActivities, (classActivity) => classActivity.data?.type !== "custom" || classActivity.data?.type === "" || classActivity?.data?.type === null);
    const adminExtension = filter(adminClassActivity, (classActivity) => combineBookId?.includes(classActivity.data?.chapter))
    const adminClassQuiz = filter(classQuizzes, (classQuiz) => classQuiz.data?.type !== "custom" || classQuiz.data?.type === "" || classQuiz?.data?.type === null);
    const adminExtensionQuiz = filter(adminClassQuiz, (classQuiz) => combineBookId?.includes(classQuiz.data?.chapter));
    const data =  {
        "activities": filter(_activities, (activity) => activity.chapter == chapter),
        "quizzes": filter(_quizzes, filterByBookId),
        "questions": [],
        "notes": filter(notes, (note) => bubbleNoteVisibleForClass(note, chapter, classId, isAssessmentBook)),
        "likes": [],
        "interactions": filter(interactions, (interaction) => interaction.chapter == chapter),
        "classActivities": filter(classActivities, (classActivity) => classActivity.data?.chapter == chapter).concat(adminExtension),
        "classQuizzes": filter(classQuizzes, filteDatarByBookId).concat(adminExtensionQuiz),
    }
  
    return data;
}
function filterPageAssignment(activities, classActivities, page, chapter) {
    return filter(activities, x => (!find(classActivities, ['data.id', x.id]) && (x.page == page || x.assessment_page_id == page || x.linked_to?.find(k => k.chapter == chapter && k.pageId == page))))
}
function filertPageClassAssignment(activities, page, chapter,combinePageId = []) {
    return filter(activities, x => (x.data?.page == page || combinePageId?.includes(x.data?.page) || x.data?.linked_to?.find(k => k.chapter == chapter && k.pageId == page) || get(x, "data.assessment_page_id") == page))
}
export const getPageData = (bookData, page, quiz, activity, isAssessmentBook, chapter) => {
    return ({
        pageInteractions: filter(bookData.interactions, x => (x.page == page && x.typeId != 'videoTeacher')),
        videoSupport: filter(bookData.interactions, x => (x.page == page && x.typeId == 'videoTeacher')),
        pageNotes: filter(bookData.notes, x => (x.page == page)),
        availableActivity: filertPageClassAssignment(bookData.classActivities, page, chapter),
        availableQuiz: filertPageClassAssignment(bookData.classQuizzes, page, chapter),
        assignableActivity: filterPageAssignment(bookData.activities, bookData.classActivities, page, chapter).filter(k=>!(k.activity_type == 'graphic_organizer'&&k.createdBy!='admin')),
        assignableQuiz: filterPageAssignment(bookData.quizzes, bookData.classQuizzes, page, chapter),
        activeQuiz: find(bookData.classQuizzes, x => (quiz && quiz != "null" && get(x, "data.id", "").includes(quiz)) || (activity && activity != "null" && get(x, "data.id", "").includes(activity))),
        activeActivity: find(bookData.classActivities, x => (quiz && quiz != "null" && get(x, "data.id", "").includes(quiz)) || (activity && activity != "null" && get(x, "data.id", "").includes(activity))),
    })
}



function filertPageClassAssignmentForExtension(activities, page, chapter,combinePageId = []) {
    return filter(activities, x => ((x?.data?.chapter == chapter && x.data?.page == page) || combinePageId?.includes(x.data?.page) || x.data?.linked_to?.find(k => k.chapter == chapter && k.pageId == page) || get(x, "data.assessment_page_id") == page))
}

function uniqueSet(data) {
  const uniqueData = [];
  const seenIds = new Set();
  for (const item of data) {
    if (!seenIds.has(item.id)) {
      seenIds.add(item.id);
      uniqueData.push(item);
    }
  }
  return uniqueData;
}


export const extenionGetPageData = (
  bookData,
  page,
  quiz,
  activity,
  isAssessmentBook,
  chapter,
  configExtensionData = {},
  from =""
) => {
 if (from !== 'extensionActivity') {
   if (configExtensionData[chapter]) {
     const pageString = page?.toString();
     if (!configExtensionData[chapter].includes(pageString)) {
       configExtensionData[chapter].push(pageString);
     }
   } else {
     configExtensionData[chapter] = [page?.toString()];
   }
 }
  let availableActivity = [];
  let availableQuiz = [];

  // Process each book and its pages
  for (const [bookId, pages] of Object.entries(configExtensionData)) {
    for (const pageId of pages) {
      const resultActivity = filertPageClassAssignmentForExtension(
        bookData.classActivities,
        pageId,
        bookId,
      );
      const resultQuiz = filertPageClassAssignmentForExtension(
        bookData.classQuizzes,
        pageId,
        bookId,
      );

      if(resultActivity?.length === 0 && resultQuiz?.length === 0){
          continue;
      }

      // Check and add activities
      if (resultActivity) {
        availableActivity.push(...resultActivity); 
      }

      // Check and add quizzes
      if (resultQuiz) {
        availableQuiz.push(...resultQuiz);
      }
    }
  }


  const result =  {
    pageInteractions: filter(
      bookData.interactions,
      (x) => x.page == page && x.typeId != 'videoTeacher',
    ),
    videoSupport: filter(
      bookData.interactions,
      (x) => x.page == page && x.typeId == 'videoTeacher',
    ),
    pageLike: filter(bookData.likes, (x) => x.page == page),
    pageNotes: filter(bookData.notes, (x) => x.page == page),
    pageQuestions: filter(bookData.questions, (x) => x.page == page),
    availableActivity: uniqueSet(availableActivity), // for assigned
    availableQuiz: uniqueSet(availableQuiz), // for assigned
    assignableActivity: filterPageAssignment(
      bookData.activities,
      bookData.classActivities,
      page,
      chapter,
    ).filter((k) => !(k.activity_type == 'graphic_organizer' && k.createdBy != 'admin')),
    assignableQuiz: filterPageAssignment(bookData.quizzes, bookData.classQuizzes, page, chapter),
    activeQuiz: find(
      bookData.classQuizzes,
      (x) =>
        (quiz && quiz != 'null' && get(x, 'data.id', '').includes(quiz)) ||
        (activity && activity != 'null' && get(x, 'data.id', '').includes(activity)),
    ),
    activeActivity: find(
      bookData.classActivities,
      (x) =>
        (quiz && quiz != 'null' && get(x, 'data.id', '').includes(quiz)) ||
        (activity && activity != 'null' && get(x, 'data.id', '').includes(activity)),
    ),
  };
    availableActivity = [];
    availableQuiz = []
  return result;
};

export const getStatusByCode = (status,currentUser) => {
    if (status == 0) {
        return ''
    } else if (status == 1) {
        return currentUser && currentUser.schoologyid ? "Exempt" : "Excused";
    } else if (status == 2) {
        return 'Incomplete'
    } else if (status == 3) {
        return 'Missing'
    } else if (status == 5) {
        return 'Absent'
    }
    else if (status == 6) {
        return 'Late'
    }
    else {
        return ""
    }
}
export const getExceptionStatus = (submission,currentUser) => {
    const exceptionStatus = submission?.exceptionStatus || 0;
    const isException = exceptionStatus > 0;
    const exceptionStatusText = getStatusByCode(exceptionStatus , currentUser )
    return { isException, exceptionStatusText, exceptionStatus }
}
export const getQuestionWithDifficulty = (question, number_of_answer) => {
    try {
      if (question.type === 'multipleResponse') {
          return question;
      } else if (question.type === "multipleChoice") {
        const ans = Number(question.answer);
        
        if (question.options && Array.isArray(question.options)) {
          const filteredOptions = [];
          const correctAnswerIndex = ans;
          
          if (question.options[correctAnswerIndex]) {
            filteredOptions.push(question.options[correctAnswerIndex]);
          }
          
          let optAdded = filteredOptions.length;
          
          question.options.forEach((opt, i) => {
            if (i !== correctAnswerIndex && optAdded < number_of_answer) {
              filteredOptions.push(opt);
              optAdded++;
            }
          });
          
          question.options = filteredOptions;
          question.answer = 0;
        }
        return question;
      }
      return question;
    } catch (error) {
      console.log(error, 123);
      return question;
    }
  };
  
export const getQuestionForDiff = (nivel, data) => {
      const value = LEVELS?.find((element) => element?.value === nivel)?.label;
      if(!value) return data;
      return map(data, qus => {
          return getQuestionWithDifficulty(qus, Number(value));
      });
  }
export const modifyAssignmentForStudent = (assignment, isStudent, isQuiz, currentUser, servertime, timezone, currentClass, hiddenBooks = []) => {
    if (!isStudent || !assignment) return assignment || null;

    const assignmentsArray = Array.isArray(assignment) ? assignment : [assignment];

    return assignmentsArray
        .map(assign => {
            const retakes = assign.retakes || '0'
            const classConfig = find(assign.classes, ['id', get(currentClass, "id")]);

            if (classConfig?.diff) {
                const { diff } = classConfig;
                const applyDiff = (diffConfig) => {
                    assign.dueDate = diffConfig.dueDateDif;
                    assign.retakes = assign.retake_added?assign.retakes: parseInt(diffConfig.retakesDif||'0',10)+parseInt(retakes,10);
                    assign.scheduleAt = diffConfig.scheduleAtDiff;
                    assign.data.questions = getQuestionForDiff(diffConfig.levelExercise, assign.data.questions);
                    assign.retake_added = true;
                };

                const hasStudentDiff = find(diff.student, id => id === currentUser.id);

                if (hasStudentDiff) {
                    applyDiff(diff);
                } else if (diff.groups?.length > 0) {
                     const filteredGroups = diff.groups.filter(group => group.student.includes(currentUser.id));
                    const groupWithMaxDueDate = filteredGroups?.length > 0 && filteredGroups.reduce((latest, current) => {
                        return new Date(current.dueDateDif) > new Date(latest.dueDateDif) ? current : latest;
                    });
                    if(groupWithMaxDueDate){
                        applyDiff(groupWithMaxDueDate)
                    }
                    // diff.groups.forEach(group => {
                    //     const hasGroupDiff = find(group.student, id => id === currentUser.id);
                    //     if (hasGroupDiff) {
                    //         applyDiff(group)
                    //     };
                    // });
                }
            }

            const isAfterSchedule = assign.scheduleAt ? isBeforTime(assign.scheduleAt, new Date()) : true;
            const deactivatedStudent = false;
            // const deactivatedStudent = assign?.deactivated_student?.includes(currentUser?.id);
            const isBookHidden = hiddenBooks.includes(assign?.data?.chapter);

            return (!isAfterSchedule || deactivatedStudent || isBookHidden) ? null : assign;
        })
        .filter(Boolean);  // Removes any null values
};
export const isEbook = (chapter, allBooks) => {
    return Boolean(find(allBooks, x => x.id == chapter))
}
export const isVideo = (chapter, resources) => {
    const allresourcesVideo = flatMap(map(resources, k => k.videos))
    return Boolean(find(allresourcesVideo, x => x.id == chapter))
}

export const getNumberMask = (chapter, _page , booksAllList ) => {
    let book = find(booksAllList, { id: chapter })
    if (book) {
        let numberMask = find(book.pages, k=>k.pageId == _page)
        if (numberMask) {
            return numberMask.NumberMasked ?? numberMask.pageId ?? _page
        } else {
            return _page;
        }
    } else {
        return _page;
    }
}
export const getAssignmentLable = (assignment, booksAllList, videos, resources) => {
    const pageId = get(assignment, "data.page")
    const chapter = get(assignment, "data.chapter")
    if (!assignment) return ""
    // const assignmentType = assignment.activityId ? 'A' : 'Q'
    if (isVideo(pageId, resources)) {
        return get(assignment, "data.displayName", "resource")
    }
    else if (isEbook(chapter, booksAllList)) {
        const numberMasked = getNumberMask(chapter, pageId, booksAllList)
        const shortName = BookSynoname[chapter]
        if (shortName && numberMasked) {
            return ` ${shortName} | Pg.${numberMasked}`
        } else if (numberMasked) {
            return ` ${chapter} | Pg.${numberMasked}`
        } else if (shortName) {
            return ` ${shortName} | Pg.${pageId}`;
        } else {
            return ` ${chapter} | Pg.${pageId}`;
        }
    } else {
        return getBookDisplayName(booksAllList, pageId, false, videos, resources)
    }
}

export const mapBookByOrderCreateUser = (books, bookOrder) => {
    if (Array.isArray(books)) {
        const resp = []
        const order = bookOrder && bookOrder.length > 0 ? bookOrder : BOOKORDER;
        order.forEach(book => {
            const bk = []
            map(book.order, id => {
                const hasBook = find(books, k => k.id == id);
                if (hasBook) {
                    bk.push(hasBook)
                }
            })
            if (bk.length > 0) {
                resp.push({
                    title: book.title,
                    color: book.color,
                    books: bk
                })
            }
        })
        return resp;
    }
    return books;
}

export const mapBookByOrderOnlyCreateUser = (books, bookOrder) => {
    if (Array.isArray(books)) {
        const resp = []
        const order = bookOrder && bookOrder.length > 0 ? bookOrder : [];
        order.forEach(book => {
            const bk = []
            map(book.order, id => {
                const hasBook = find(books, k => k.id == id);
                if (hasBook) {
                    bk.push(hasBook)
                }
            })
            if (bk.length > 0) {
                resp.push({
                    title: book.title,
                    color: book.color,
                    books: bk
                })
            }
        })
        return resp;
    }
    return books;
}

export const groupBookByOrder = (books, bookOrder) => {
    if (Array.isArray(books)) {
        const resp = []
        const order = bookOrder && bookOrder.length > 0 ? bookOrder : BOOKORDER;
        order.forEach(book => {
            const bk = []
            map(book.order, id => {
                const hasBook = find(books, k => k.id == id);
                if (hasBook) {
                    bk.push(hasBook)
                }
            })
            if (bk.length > 0) {
                resp.push({
                    title: book.title,
                    color: book.color,
                    books: bk,
                    key:book.key
                })
            }
        })
        return resp;
    }
    return books;
}

export const isBookAllowed = (resourse_allowed, data, type, userBooks) => {
  const chapter = get(data, 'data.chapter') ?? get(data, 'assignment.chapter');
  if (typeof resourse_allowed === "boolean" && resourse_allowed && chapter?.length > 9) {
    return true;
  } else if (['debate'].includes(type)) {
    return true;
  } else if (userBooks.some(k => k == chapter)) {
    return true;
  } else {
    return false;
  }
}


export  const getUserAssignment = (userBooks , assignments, currentUser,currentClass, resourse_allowed,activeStudentParent) => {
    const userassignment = filter(assignments, e => {
        const chapter = get(e, "data.chapter", '');
        const type = get(e, "type", "");
        return typeof resourse_allowed =="boolean" && resourse_allowed && chapter?.length > 9 || ['debate', 'game', 'bingo', 'worksheet'].includes(type) ? true : userBooks.some(k => k == chapter);
    })
    return userassignment.map(k=>{
        const hasDiff = find(k.diff, ["userId",( currentUser?.role === 'parent' ? activeStudentParent ? activeStudentParent :currentUser?.parent_of : currentUser.id)])
        const classConfig = find(k.classes,['id',get(currentClass,"id")])
        if (hasDiff) {
            k.lateDate = get(hasDiff, "lateDate", k.lateDate)
            k.scheduleAt = get(hasDiff, "scheduleAt", k.scheduleAt)
            k.dueDate = get(hasDiff, "dueDate", k.dueDate)
            k.retakes = get(hasDiff, "retakes", k.retakes)
            k.timeDuration = get(hasDiff, "timeDuration") > 0 ? get(hasDiff, "timeDuration") : k.timeDuration
        }
        if(classConfig&&classConfig.diff){
            const hasClassDiff = find(classConfig.diff.student, k => k == currentUser?.role === 'parent' ? activeStudentParent ? activeStudentParent : currentUser?.parent_of : currentUser.id)
            if(hasClassDiff){
                k.dueDate = classConfig.diff.dueDateDif;
                k.retakes = classConfig.diff.retakesDif;
                k.scheduleAt = classConfig.diff.scheduleAtDiff;
            }
        }
        return k;
    }).filter(k=>{
        const scheduleAt = get(k,"scheduleAt");
        if (scheduleAt && moment(scheduleAt).isValid()) {
            const isAfterSchedule = moment().diff(moment(scheduleAt), 'minutes') >= 0;
             return isAfterSchedule;
        }else{
            return true;
        }
    })
}

export const getStoryUrl = (story, bookId, pageId, quiz, activity) => {
    const hasStories = filter(story, ["bookId", bookId]) // for story
    if (hasStories.length > 0) {
        let storyId = null;
        let level = null;
        map(hasStories, st => {
            map(st.levels, lv => {
                if (lv) {
                    if (parseInt(pageId) >= parseInt(lv.start) && parseInt(pageId) <= parseInt(lv.finish)) {
                        storyId = st.id;
                        level = lv.level;
                    }
                }
            })
        })
        if (storyId && level) {
            return `/stories?id=${storyId}&page=${pageId}&level=${level}&activity=${activity}&quiz=${quiz}`
        }
    } else {
        return null;
    }
}
export const filterStoryClassQuizOrActivity = (data,story) => {
    return filter(data, k => find(story,["bookId",get(k, "data.chapter")]))
}
export const filterNonStoryClassQuizOrActivity = (data,story) => {
    return filter(data, k => !find(story,["bookId",get(k, "data.chapter")]))
}

export const filterMainGradebookClassQuizOrActivity = (data, story, exam) => {
  return filter(data, (k) => {
    // const bookId = get(k, "data.chapter")
    // const hasInExam = find(exam, k=>k.bookId ==  bookId);
    // const hasInStory = false;
    // const hasInStory = find(story,k=>k.bookId ==  bookId);
    // if (hasInExam || hasInStory) {
    //   return false;
    // }
    return true;
  });
};
export const groupLinkedSection = (classes, isSchoologyUser) => {
    const group_classes = {};
    if (!isSchoologyUser) return group_classes;

    const usedClassIds = new Set();

    const parentClasses = filter(classes, k => Number(k.schoology_parent_id) === 0);

    map(parentClasses, parent => {
        const childClasses = filter(classes, ["schoology_parent_id", parent.sectionId]);
        const group = [...childClasses, parent].filter(c => !usedClassIds.has(c.id));
        if (group.length > 1) {
            group_classes[parent.id] = group;
            map(group, c => usedClassIds.add(c.id));
        }
    });

    const keysWithGroups = new Set(Object.keys(group_classes).map(k => Number(k)));

    const classesWithParentId = filter(classes, k => Number(k.schoology_parent_id) !== 0);
    const groupedByParentId = {};

    map(classesWithParentId, cls => {
        const pid = Number(cls.schoology_parent_id);
        if (!groupedByParentId[pid]) {
            groupedByParentId[pid] = [];
        }
        groupedByParentId[pid].push(cls);
    });

    Object.keys(groupedByParentId).forEach(pidStr => {
        const pid = Number(pidStr);
        if (keysWithGroups.has(pid)) {
            return;
        }
        const group = groupedByParentId[pid].filter(c => !usedClassIds.has(c.id));
        if (Array.isArray(group) && group.length > 1) {
            group_classes[pid] = group;
            map(group, c => usedClassIds.add(c.id));
        }
    });

    return group_classes;
}
export const generateUrlForNonEbook = (id, page, activity, quiz, backToLabel, level, CHAPTER_ID, is_graphic_organizer) => {
    if (backToLabel == 'Balcón cultural') {
        if (!is_graphic_organizer) {
            return `/balconCulturalBook?id=${id}&page=${page}&activity=${activity}&quiz=${quiz}`
        } else {
            return `/balconCulturalBook?id=${id}&page=${page}&assignment_type=graphic_organizer&activity_id=${activity}`
        }
    }
    if (backToLabel == '1nformate lessons') {
        if (!is_graphic_organizer) {
            return `/informateBook?id=${id}&page=${page}&activity=${activity}&quiz=${quiz}`;
        } else {
            return `/informateBook?id=${id}&page=${page}&assignment_type=graphic_organizer&activity_id=${activity}`;
        }
    }
    if (backToLabel == 'Comunidad') {
        if (!is_graphic_organizer) {
            return `/ComunidadBook?id=${id}&page=${page}&activity=${activity}&quiz=${quiz}`;
        } else {
            return `/ComunidadBook?id=${id}&page=${page}&assignment_type=graphic_organizer&activity_id=${activity}`;
        }
    }
    if (backToLabel == 'Conectándome') {
        if (!is_graphic_organizer) {
            return `/ConectandomeBook?id=${id}&page=${page}&activity=${activity}&quiz=${quiz}`;
        } else {
            return `/ConectandomeBook?id=${id}&page=${page}&assignment_type=graphic_organizer&activity_id=${activity}`;
        }
    }
    if (backToLabel == 'Worksheet') {
        if (!is_graphic_organizer) {
            return `/worksheet-1NFORMATE?id=${id}&page=${page}&activity=${activity}&quiz=${quiz}`;
        } else {
            return `/worksheet-1NFORMATE?id=${id}&page=${page}&assignment_type=graphic_organizer&activity_id=${activity}`;
        }
    }
    if (backToLabel == 'Graphic Organizers') {
        if (!is_graphic_organizer) {
            return `/graphic-organizers-book?id=${id}&page=${page}&activity=${activity}&quiz=${quiz}`;
        } else {
            return `/graphic-organizers-book?id=${id}&page=${page}&assignment_type=graphic_organizer&activity_id=${activity}`;
        }
    }
    if (backToLabel == 'AP') {
        if (!is_graphic_organizer) {
            return `/apBook?chapter=${CHAPTER_ID}&id=${id}&page=${page}&activity=${activity ?? null}&quiz=${quiz ?? null}`;
        } else {
            return `/apBook?chapter=${CHAPTER_ID}&id=${id}&assignment_type=graphic_organizer&activity_id=${activity}`;
        }
    }
    if (backToLabel == 'Stories') {
        if (!is_graphic_organizer) {
            return `/stories?id=${id}&level=${level}&page=${page}&activity=${activity ?? null}&quiz=${quiz ?? null}`;
        } else {
            return `/stories?id=${id}&level=${level}&page=${page}&assignment_type=graphic_organizer&activity_id=${activity ?? null}`;
        }
    }
}

export const getEbookAssignmentDeepLinkUrl = (data) => {
    if (!data) return null;
    const isWorksheet =
        data.type === "worksheet" || data?.assignmentType === "worksheet";
    if (isWorksheet) {
        const assignmentData = data.data ? data.data : data.assignment ;
        const chapter = assignmentData?.chapter;
        const page = assignmentData?.page;
        const worksheetId = data?.game_id ?? data?.data?.game_id;
        if (
            chapter === undefined ||
            chapter === null ||
            chapter === "" ||
            page === undefined ||
            page === null ||
            worksheetId === undefined ||
            worksheetId === null
        ) {
            return null;
        }
        return `/ebook?chapter=${chapter}&page=${page}&assignment_type=worksheet&worksheet_id=${worksheetId}`;
    }
    if (
        data?.data?.activity_type === "graphic_organizer" ||
        data?.data?.type === "graphic_organizer"
    ) {
        const assignmentData = data.data ? data.data : data.assignment ;
        const chapter = assignmentData?.chapter;
        const page = assignmentData?.page;
        if (
            chapter === undefined ||
            chapter === null ||
            chapter === "" ||
            page === undefined ||
            page === null ||
            data.id === undefined ||
            data.id === null
        ) {
            return null;
        }
        return `/ebook?chapter=${chapter}&page=${page}&assignment_type=graphic_organizer&id=${data.id}`;
    }
    return null;
};

export const getAssignmentNavigationUrl = (url, data) => {
    if (!url||!data) return url;
    const assignmentData = data?.data ? data.data : data?.assignment;
    const resolvedAssignmentId = assignmentData?.id;
    const isWorksheet =
        data?.type === "worksheet" ||
        data?.assignmentType === "worksheet" ||
        data?.data?.assignmentType === "worksheet";
    const worksheetId = data?.game_id ?? data?.data?.game_id ?? resolvedAssignmentId;
    const safeUrl = String(url);
    try {
        const isAbsolute = /^https?:\/\//i.test(safeUrl);
        const parsedUrl = new URL(
            safeUrl,
            isAbsolute ? undefined : "http://local.app"
        );
        if (isWorksheet && worksheetId) {
            parsedUrl.searchParams.set("assignment_type", "worksheet");
            parsedUrl.searchParams.set("worksheet_id", worksheetId);
        }
        const newUrl = isAbsolute
            ? parsedUrl.toString()
            : `${parsedUrl.pathname}${parsedUrl.search}`;
        return newUrl;
    } catch (error) {
        const separator = safeUrl.includes("?") ? "&" : "?";
        if (isWorksheet && worksheetId) {
            let newUrl = `${safeUrl}${separator}assignment_type=worksheet&worksheet_id=${worksheetId}`;
            return newUrl;
        }
        let newUrl = safeUrl;
        return newUrl;
    }
};

export function updateUrlPathWithActivityOrQuiz(originalUrl, activity = null, quiz = null) {
    const url = new URL(originalUrl);
    const updateQueryParam = (param, value) => {
      if (value !== null && url.searchParams.get(param) === 'null') {
        url.searchParams.set(param, value);
      }
    };
    updateQueryParam('activity', activity);
    updateQueryParam('quiz', quiz);
    return `${url.pathname}${url.search}`;
  }

export  const getBackToUrl =(backToLabel,CHAPTER_ID,isTablate ,isMobile)=>{
    if(backToLabel == 'AP'&&CHAPTER_ID){
        return `/ap?id=${CHAPTER_ID}`
    }
    if(backToLabel == '1nformate lessons'){
        return `/informate`
    }
    if(backToLabel == 'Balcón cultural'){
        if (!isTablate && !isMobile) {
            return `/balconCultural`
        } else {
            return '/OneWayLessons'
        }
    }
    if(backToLabel == 'Comunidad'){
        if (!isTablate && !isMobile) {
            return `/comunidad`
        } else {
            return '/OneWayLessons'
        }
    }
    if(backToLabel == 'Conectándome'){
        if (!isTablate && !isMobile) {
            return `/Conectandome`
        } else {
            return '/OneWayLessons'
        }
    }
    if(backToLabel == 'Worksheet'){
        return `/worksheet`
    }
    if(backToLabel == 'Graphic Organizers') {
        return `/graphic-organizers`
    }
    if(backToLabel == 'AP') {
        return `/graphic-organizers`
    }
    if(backToLabel == 'Stories'){
        return "/story-levels"
    }
}

export const checkIsDiffForUser = (classConfig, user_id) => {
    let isDiffStudent = false
    try {
        if (classConfig && classConfig.diff) {
            isDiffStudent = Boolean(find(classConfig.diff.student, k => k == user_id))
            if (!isDiffStudent && classConfig.diff.groups&&classConfig.diff.groups.length>0) {
                const users = classConfig.diff.groups.flatMap(k=>k.student)
                return !!users.find(k=>k==user_id)
            }
        }
    } catch (error) {
        Sentry.captureException(`648 Error in checkIsDiffForUser: ${error}`);
    }
    return isDiffStudent;
}

export const getConfigForDiff = (classConfig, user_id) => {
    let config = { }
    try {
        if (classConfig && classConfig.diff) {
           let  isDiffStudent = Boolean(find(classConfig.diff.student, k => k == user_id))
            if(isDiffStudent){
                config = classConfig.diff;
            }
            if (!isDiffStudent && classConfig.diff.groups&&classConfig.diff.groups.length>0) {
                classConfig.diff.groups.forEach(group =>{
                    if(group.student.find(k=>k==user_id)){
                        config = group;
                    }
                })
            }
        }
    } catch (error) {
        Sentry.captureException(`649 Error in getConfigForDiff: ${error}`);
    }
    return config;
}

export const shouldSkipLateDateForDiffStudent = (assignment, currentUser, currentClass) => {
    try {
        if (!assignment || !currentUser || !currentClass) return false;
        
        const classConfig = find(assignment.classes, ['id', get(currentClass, "id")]);
        if (!classConfig || !classConfig.diff) return false;
        
        const isDiffStudent = checkIsDiffForUser(classConfig, currentUser.id);
        if (!isDiffStudent) return false;
        return true;
    } catch (error) {
        Sentry.captureException(`650 Error in shouldSkipLateDateForDiffStudent: ${error}`);
        return false;
    }
}

export const filterStudentSubmission = (weekAssignmentPast, type, submissions) => {
    const filteredData = weekAssignmentPast
        .filter(answer => {
            const assignment = submissions.find(item => item.data?.id === answer.data?.id)?.submission || {};
            const diff = get(assignment, "diff[0]");
            let retakeAvailable = false;

            if (diff) {
                retakeAvailable = assignment ? parseInt(get(assignment, "submissions", 0), 10) < (parseInt(get(diff, "retakes"), 10) + 1) : true;
            } else {
                retakeAvailable = assignment ? parseInt(get(assignment, "submissions", 0), 10) < (parseInt(get(answer, "retakes"), 10) + 1) : true;
            }
            const completed = !retakeAvailable && get(assignment, "complete", false);
            const retake = retakeAvailable && !completed;
            return retake;
        })
        
    const getMissingFilter = filter(filteredData, a => a.lateDate && moment(a.dueDate).isBefore(moment(), "minute") && moment(a.lateDate).isAfter(moment(), "minute"));
    const getDueFilter = filter(filteredData, a => moment(a.dueDate).isSame(moment(), "day") && moment(a.dueDate).isAfter(moment(), "minute") && !moment(a.scheduleAt).isSame(moment(), "day"))
    const getStartFilter = filter(filteredData, a => moment(a.scheduleAt).isSame(moment(), "day") && moment(a.scheduleAt).isBefore(moment(), "minute") && moment(a.dueDate).isAfter(moment(), "minute"))
    if (type === 'missing') {
        return getMissingFilter;
    } else if (type === 'due'){
        return getDueFilter;
    } else {
        return getStartFilter;
    }
};
function getPositionInRange(number, start, finish) {
    return parseInt(number) - parseInt(start) + 1;
}

const findUnitsContainingNumber = (data, targetNumber) => {
    // Convert target to number to ensure proper comparison
    targetNumber = parseInt(targetNumber);
    
    const matchingUnits = data?.find(unit => {
        // Convert start and finish to numbers
        const start = parseInt(unit.start);
        const finish = parseInt(unit.finish);
        
        // Check if targetNumber falls within the range (inclusive)
        return targetNumber >= start && targetNumber <= finish;
    });
    
    const maskId = getPositionInRange(targetNumber, matchingUnits?.start,matchingUnits?.finish);
    return {
        matchingUnits: matchingUnits,
        maskId: maskId
    }
};

export const getNonAssignableMaskId = (allBookUnits,assignment) => {
  const book = allBookUnits?.find((x) => Number(x.bookId)  === Number(assignment?.data?.bookId));
  const bookUnit = book?.pages;
  
  const result = findUnitsContainingNumber(bookUnit, assignment?.data?.page);

    return {
        shortName: result?.matchingUnits?.shortName,
        maskId: result?.maskId
    }
} 
export const modifyStudentAssignment = (assignment, userId, classId) => {
    if (!assignment) return null;

    const assignmentsArray = Array.isArray(assignment) ? assignment : [assignment];

    const applyDiff = (assign, diffConfig, retakes) => {
        assign.dueDate = diffConfig.dueDateDif;
        assign.retakes = assign.retake_added
            ? assign.retakes
            : parseInt(diffConfig.retakesDif || '0', 10) + parseInt(retakes, 10);
        assign.scheduleAt = diffConfig.scheduleAtDiff;
        assign.data.questions = getQuestionForDiff(diffConfig.levelExercise, assign.data.questions);
        assign.retake_added = true;
    };

    return assignmentsArray
        .map((assign) => {
            const retakes = assign.retakes || '0';
            const classConfig = find(assign.classes, ['id', classId]);

            if (classConfig?.diff) {
                const { diff } = classConfig;
                const hasStudentDiff = find(diff.student, (id) => id === userId);
                if (hasStudentDiff) {
                    applyDiff(assign, diff, retakes);
                } else if (diff.groups?.length > 0) {
                    for (const group of diff.groups) {
                        if (find(group.student, (id) => id === userId)) {
                            applyDiff(assign, group, retakes);
                            break;
                        }
                    }
                }
            }
            return assign;
        })
        .filter(Boolean);
};

 export function sortByCustomType(activities) {
    return [...activities].sort((a, b) => {
      const isACustom = a.type?.toLowerCase() === 'custom';
      const isBCustom = b.type?.toLowerCase() === 'custom';
  
      // Sort by custom type first (non-custom before custom)
      if (!isACustom && isBCustom) return -1;
      if (isACustom && !isBCustom) return 1;
      
      // Only compare displayName if both items have it
      if (a.displayName && b.displayName) {
        return a.displayName.localeCompare(b.displayName);
      }
      
      // If only one has displayName, prioritize the one with displayName
      if (a.displayName && !b.displayName) return -1;
      if (!a.displayName && b.displayName) return 1;
      
      // If neither has displayName, maintain original order
      return 0;
    });
  }

export const getClassAllowedBooks = (orgPermissions, currentClass, userAllowedBooks, bookOrder,currentUser,booksAllList) => {
  const booksGroupPermission = get(orgPermissions, "books_group_permission", []);
  const archivedGroup = currentClass.archived_group || [];
  const classBooksGroup = currentClass.books_group || [];

  const isStudent = currentUser.role === "student";
  const allowedGroups = booksGroupPermission.length === 0 
    ? classBooksGroup 
    : classBooksGroup.filter(group => booksGroupPermission.includes(group));
  const mainBooks = [];
  for (const key of allowedGroups) {
    if (archivedGroup.includes(key)) continue;
    const order = find(bookOrder, ["key", key]);
    if (!order || !Array.isArray(order.order)) continue;
    for (const chapterId of order.order) {
      const book = find(booksAllList, v=>v?.id==chapterId);
      if (!book||!book?.id) continue;
      if (isStudent && book.onlyTeacher) continue;
        mainBooks.push(chapterId);
    }
  }
  // Add extra books and external link books
  if (Array.isArray(userAllowedBooks.extra_books)) {
    mainBooks.push(...userAllowedBooks.extra_books);
  }
  if (Array.isArray(userAllowedBooks.externalLinkBooks)) {
    mainBooks.push(...userAllowedBooks.externalLinkBooks);
  }

  return mainBooks;
};
export const subMissionViewTBG = ({isPointSystem, isTbg, face_grade, bg_text, max_point, grade}) => {
  if (isPointSystem) {
    if (isTbg) {
      return face_grade ? `${face_grade} (${bg_text})/${max_point}` : `${bg_text}/${max_point}`;
    }
    return face_grade > 0 || face_grade == 0 ? `${face_grade}/${max_point}` : `0/${max_point}`;
  } else {
    if (isTbg) {
      return grade == 0 || grade > 0 ? `${grade} (${bg_text})` : bg_text;
    }
    return grade == 0 || grade > 0 ? grade : '-';
  }
};

export const getUnitsPages = (currentPageId, bookUnits, pages = []) => {
  const currentPageIndex = pages.findIndex(page => String(page.pageId) === String(currentPageId));
  
  if (currentPageIndex === -1) {
    return { unit: null, subunit: null, pagesInRange: [] };
  }
  
  if (!Array.isArray(bookUnits)) {
    return { unit: null, subunit: null, pagesInRange: [] };
  }
  
  let unit = null;
  let unitStartIndex = -1;
  let unitFinishIndex = -1;
  
  for (const u of bookUnits) {
    const startPageId = String(u.start);
    const finishPageId = String(u.finish);
    
    const startIndex = pages.findIndex(page => String(page.pageId) === startPageId);
    const finishIndex = pages.findIndex(page => String(page.pageId) === finishPageId);
    
    if (startIndex !== -1 && finishIndex !== -1 && 
        currentPageIndex >= startIndex && currentPageIndex <= finishIndex) {
      unit = u;
      unitStartIndex = startIndex;
      unitFinishIndex = finishIndex;
      break;
    }
  }
  
  if (!unit) {
    return { unit: null, subunit: null, pagesInRange: [] };
  }
  
  let subunit = null;
  let rangeStartIndex = unitStartIndex;
  let rangeFinishIndex = unitFinishIndex;
  
  if (unit.subUnits && Array.isArray(unit.subUnits)) {
    for (const su of unit.subUnits) {
      const startPageId = String(su.start);
      const finishPageId = String(su.finish);
      
      const startIndex = pages.findIndex(page => String(page.pageId) === startPageId);
      const finishIndex = pages.findIndex(page => String(page.pageId) === finishPageId);
      
      if (startIndex !== -1 && finishIndex !== -1 && 
          currentPageIndex >= startIndex && currentPageIndex <= finishIndex) {
        subunit = su;
        rangeStartIndex = startIndex;
        rangeFinishIndex = finishIndex;
        break;
      }
    }
  }
  
  const pagesInRange = pages.slice(rangeStartIndex, rangeFinishIndex + 1);
  
  return {
    unit: unit,
    subunit: subunit,
    pagesInRange: pagesInRange
  };
}

export const GRADE_PREF = [
    { key: "average", value: "Average Grade" },
    { key: "scale_1_5", value: "Grade in 0-4" },
    { key: 'gradebook_a_f', value: "Gradebook with A-F" }
]
export const removeQuestionError = (i, questions, setError) => {
    setError(prev => prev.filter(err => {
        if (err.questionIndex === i) return false;
        if (err.questionIndices?.includes(i)) {
            return err.questionIndices.length > 1;
        }
        return true;
    }));
}

export const getCurrentResourceType = (sourceBookId) => {
    if (String(sourceBookId) === '43') {
      return resource_types.comunidad;
    }
    if (String(sourceBookId) === '49') {
      return resource_types.conectándome;
    }
    if (String(sourceBookId) === '33') {
      return resource_types.balcon;
    }
    if (String(sourceBookId) === '41') {
      return resource_types.informate;
    }
    if (String(sourceBookId) === '255') {
      return resource_types.story;
    }
    if (['70','69','71','72','73','75','78'].includes(String(sourceBookId))) {
      return resource_types.AP;
    }
    return null;
  };